<template>
  <div :class="{ 'flex-row-reverse': !isSignFirst }" class="flex [word-break:break-word]">
    <div class="-mt-0.5 text-[60%]">{{ value?.currency?.symbol }}</div>

    <div :class="{ 'line-through': isOldPrice }">
      {{ displayAmount }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { toPersianDigits } from "@/core/utilities";
import type { MoneyType } from "@/core/api/graphql/types";

interface IProps {
  value?: MoneyType;
  isOldPrice?: boolean;
}

const props = defineProps<IProps>();

const { locale } = useI18n();

const displayAmount = computed(() => {
  if (!props.value?.formattedAmountWithoutCurrency) {
    return "N/A";
  }
  
  // Convert to Persian digits for fa locale
  if (locale.value === "fa" || locale.value === "fa-IR") {
    return toPersianDigits(props.value.formattedAmountWithoutCurrency);
  }
  
  return props.value.formattedAmountWithoutCurrency;
});

const isSignFirst = computed<boolean>(
  () => (props.value?.formattedAmount.search(/\d/) && props.value?.formattedAmount.search(/\d/) > 0) || false,
);
</script>
